import { GET_TICKETS, GET_TICKET_STATUS } from '../actionTypes/TicketActionType';

const INIT_STATE = {
  ticketStatus: [],
  ticketList: [],
};

const ticketReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TICKET_STATUS: {
      return { ...state, ticketStatus: action.payload };
    }
    case GET_TICKETS: {
      return { ...state, ticketList: action.payload };
    }
    default:
      return state;
  }
};

export default ticketReducer;
